export const imageStringToFile = async (image) => {
  if (image.startsWith("data:")) {
    const [header, base64Data] = image.split(",");
    const mimeType = header.match(/data:([^;]+)/)?.[1] ?? "image/png";
    const extension = mimeType.split("/")[1] ?? "png";
    const binary = atob(base64Data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new File([bytes], `image.${extension}`, { type: mimeType });
  }

  const response = await fetch(image);
  const blob = await response.blob();
  const extension = blob.type.split("/")[1] ?? "png";
  return new File([blob], `image.${extension}`, { type: blob.type });
};
